import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'removeDuplicate',
    standalone: false
})
export class RemoveDuplicatePipe implements PipeTransform {
  transform(valueArr: any): any {
    const uniqueArray = valueArr.filter((item, pos) => valueArr.indexOf(item) == pos);
    return uniqueArray;
  }
}
